import { apiUrl } from "helpers/constants/config.constants";
import { httpGet, httpPost } from "./http.service";

export interface Notification {
  notificationId: string
  userId: string
  title: string
  type?: 'order' | 'news'
  message: string
  payload?: object
  status?: string
  createdAt?: Date
  updatedAt?: Date
}

export const doListNotification = (type: string, skip: number) => {
  return new Promise((resolve, reject) => {
    httpGet(apiUrl.notification.list(type), { skip }).then((response) => {
      resolve(response);
    }).catch((error) => {
      reject(error);
    })
  });
}

export const doSendBatchNotification = (notification: Record<string, unknown>) => {
  return new Promise((resolve, reject) => {
    httpPost(apiUrl.notification.sendBatch, notification).then((response) => {
      resolve(response);
    }).catch((error) => {
      reject(error);
    })
  });
}
